export default __webpack_public_path__ + "static/media/writing.8b74cc48.svg";